import * as audioActionTypes from './types';
import * as audioActions from './actions';
import reducer from './reducer';

export {
  audioActionTypes,
  audioActions
};

export default reducer;